import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import './menu.scss';
import {DimensionContext} from "../App/dimension-context";
import {ReactComponent as Home} from "./home.svg";
import {ReactComponent as Blog} from "./blog.svg";
import {ReactComponent as Category} from "./category.svg";
import {ReactComponent as Tag} from "./tag.svg";
import {ReactComponent as Search} from "./search.svg";
import {ReactComponent as Contact} from "./contact.svg";

function Menu() {
    const dimensionContext = useContext(DimensionContext)
    const [menuOpen, toggleMenu] = useState(false)

    return <nav style={{height: menuOpen ? dimensionContext.height : 0}}
                className={"noselect bt-menu" + (menuOpen ? " bt-menu-open" : '')}>
        <button onClick={() => toggleMenu(!menuOpen)} className="bt-menu-trigger">
            <span>Menu</span>
        </button>
        <ul>
            <li><Link title="Home" to='/' className="bt-icon"><Home alt="Home"/>Home</Link></li>
            <li><Link title="Search" to='/search' className="bt-icon"><Search alt="Search"/> Search</Link></li>
            <li><Link title="Blog" to='/blog' className="bt-icon"><Blog alt="Blog"/>Blog</Link></li>
            <li><Link title="Categories" to="/categories" className="bt-icon"><Category alt="Category"/>Categories</Link></li>
            <li><Link title="Tags" to="/tags" className="bt-icon"><Tag alt="Tag"/>Tags</Link></li>
            <li><Link title="Contact" to="/contact" className="bt-icon"><Contact alt="Contact"/>Contact</Link></li>

        </ul>
        <div className="bt-overlay" onClick={() => menuOpen && toggleMenu(false)}/>
    </nav>
}

export default Menu